import * as React from 'react';
import { useServiceStatusLogs } from '../hooks/useServiceStatusLogs';
import { ILastProcessedProps } from './lastProcessed.types';
import StatusServiceTableLogs from './ServiceStatusLogsTable';

const LastProcessed = (props: ILastProcessedProps) => {
  const [etlLogs, logsActions] = useServiceStatusLogs(props);
  return (
    <div className="col-12 white-background col lastLogs">
      {props.mode === "etl" && <h5>Executed processes:</h5>}
      {props.mode === "rek" && <h5>Processed images:</h5>}
      <StatusServiceTableLogs
        logs={etlLogs.data}
        loading={etlLogs.isLoading}
        total={etlLogs.total}
        onSizeChanged={(size, page): void => logsActions.setSearchLogs(prevSearch => ({ ...prevSearch, size, page: page - 1 }))}
        onPageChanged={(page): void => logsActions.setSearchLogs(prevSearch => ({ ...prevSearch, page: page - 1 }))}
        onSort={logsActions.handleSort}
        mode={props.mode}
      />
    </div>
  );
}

export default LastProcessed;
